export const GET_VISNETWORK_DATA = '/api/visNetworkData/get-visNetwork-data'
export const GET_LAST_SESSION_URL = '/api/get-last-session-url'
export const SAVE_LAST_SESSION_URL = '/api/save-last-session-url'

// saving url
export const GET_SAVED_URLS = '/api/get-saved-urls'
export const SAVE_NEW_URL = '/api/save-new-url'
export const DELETE_SAVED_URL = '/api/delete-saved-url'
export const GET_INDEX_URL = '/api/get-index-url'

// new apis
export const GET_CONTACTS_BY_ID = '/api/get-contacts-by-id'
export const GET_CONTACTS_BY_VALUE = '/api/get-contacts-by-value'
export const GET_SEARCH_BY_VALUE = '/api/get-search-by-value'
export const GET_CUSTOMER_BY_ID = '/api/get-customer-by-id'
export const GET_CUSTOMER_BY_VALUE = '/api/get-customer-by-value'
export const GET_CUSTOMER_BY_NAME = '/api/get-customer-by-name'
export const GET_RETAILERS = '/api/get-retailers'
export const GET_RETURNS_BY_ID = '/api/get-returns-by-id'
export const GET_DASHBOARD_METRICS = '/api/get-dashboard-metrics'
export const GET_NETWORK_STATE = '/api/get-network-state'
export const GET_EXPLORER_BUILDER = '/api/get-explorer-builder'
export const GET_REPORTS = '/api/get-reports'
export const GET_DATA = '/api/get-data'
export const POST_DATA = '/api/post-data'
export const GET_CUSTOMER_EDGE = '/api/get-customer-edge'
